import type { QueryClient } from '@tanstack/react-query'
import { useAuthStore } from '@/stores/auth-store'

/**
 * Reset auth cookies/state and optionally clear React Query cache.
 * Used by manual sign-out, 401 session expiry, and idle timeout flows.
 */
export function resetSessionAndClearQuery(queryClient?: QueryClient) {
  const { auth } = useAuthStore.getState()
  auth.reset()
  queryClient?.clear()
}

